import React from 'react';
import { Grid, TextField, Button, InputAdornment } from '@material-ui/core'

import LS from '../../providers/LocalStorage'
import Ws from '../../providers/Ws';
import SpecificComponent from '../../commons/SpecificComponent';
import wallStreet from '../../Pics/wallStreet.jpg'
import ReCAPTCHA from 'react-google-recaptcha';
import SignUp from './SignUp';

export default class Login extends SpecificComponent {
    constructor(props) {
        super(props);
        this.recaptchaRef = React.createRef();
        this.state = {
            u: '',
            p: '',
            verifyCaptcha: false,
            logIn: true,
            mistakenPass: 10
        }
    }



    componentDidMount() {

    }

    onSubmitWithReCAPTCHA = async () => {
        const token = await this.recaptchaRef.current.executeAsync();

        console.log('token :>> ', token);
    }

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
        });
    };

    checkAndLogin = async () => {

        if (this.state.verifyCaptcha) {
            let WS = new Ws()
            let loginServerResponse = await WS.login(this.state.u, this.state.p);
            console.log('loginServerResponse = ', loginServerResponse)


            if (this.state.mistakenPass - 1 === 0) {

                this.setState({
                    labRez: this.dictionary.login.parolaGresita,
                    mistakenPass: 1
                }, () => {
                    const timer = setTimeout(() => {
                        this.setState({
                            labRez: '',
                            mistakenPass: 10
                        })
                    }, 90000);

                    return () => clearTimeout(timer);


                })



            } else {
                if (loginServerResponse.Succes) {
                    new LS().SetUserData(loginServerResponse.Content)

                    // console.log('All right simulare save = ')

                    let getUserRights = await WS.customSelect('select u.*, a.id, ad.sef_departament from useri u left join angajati a on u.id = a.id_user left join angajati_departamente ad on ad.id_angajat = a.id where u.id = @p1', {
                        p1: new LS().GetUserData().InfoUser.IdUser
                    })

                    if (getUserRights.Succes) {
                        let obj = new LS().GetUserData();

                        obj.InfoUser.IsAdmin = getUserRights.Content[0].is_admin
                        obj.InfoUser.DrepturiAngajati = getUserRights.Content[0].modifica_angajati
                        obj.InfoUser.AccesProiecte = getUserRights.Content[0].access_proiecte
                        obj.InfoUser.CreazaProiecte = getUserRights.Content[0].creaza_proiecte
                        obj.InfoUser.EsteSef = getUserRights.Content[0].sef_departament
                        obj.InfoUser.AccessFinanciar = getUserRights.Content[0].access_financiar

                        console.log('obj :>> ', obj);



                        let getNrMaxUtilizatori = await WS.customSelect(`select * from pm_management.[dbo].societati where db = @p1 and isnull(sters,0) != 1`, {
                            p1:obj.InfoUser.Database
                        })

                        console.log('getNrMaxUtilizatori :>> ', getNrMaxUtilizatori);

                        if(getNrMaxUtilizatori.Succes){
                            obj.InfoUser.NrMaxUtilizatori = getNrMaxUtilizatori.Content.length > 0 ? getNrMaxUtilizatori.Content[0].nr_max_utilizatori : 0

                            new LS().SetUserData(obj)

                            this.props.history.push('/');
                            document.location.reload();
                        }else{
                            new LS().SetUserData(obj)

                            this.props.history.push('/');
                            document.location.reload();
                        }


                   

                    }


                }

                else {
                    this.setState({
                        labRez: loginServerResponse.Messsage,
                        mistakenPass: this.state.mistakenPass - 1
                    })
                }

            }



            // let toSave = {idUser:'777', nume:'Popescu'}

        } else {
            this.setState({ labRez: 'Check if you are human' })
        }



    }

    changeCaptcha = async () => {
        console.log('capcha verified :>> ');

        this.setState({ verifyCaptcha: true })
    }


    changeView = () => {
        this.setState({ logIn: this.state.logIn ? false : true })
    }


    render() {
        return (
            <div style={{ marginTop: -80, width: '100%', minHeight: '120vh' }}>

                <div className="pm-login-bg-image" style={{ backgroundImage: `url(${wallStreet})` }} ></div>

                {this.state.logIn &&

                    <Grid container className="loginContainer" style={{ borderRadius: 16, marginBottom: 40, marginTop: '35vh' }} >

                        <Grid style={{}} item xs={12} sm={12} md={12} lg={12} xl={12} >
                            <TextField
                                className="loginTextField inputFocus"
                                id="with-placeholder"
                                label={this.dictionary.login.user}
                                margin="normal"
                                value={this.state.u}
                                onChange={this.handleChange('u')}
                                InputProps={{
                                    startAdornment: <InputAdornment position="start"><i className='material-icons pm-input-icon'>email</i></InputAdornment>,
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                            <TextField
                                className="loginTextField inputFocus"
                                id="password-input"
                                label={this.dictionary.login.password}
                                type="password"
                                margin="normal"
                                value={this.state.p}
                                onChange={this.handleChange('p')}
                                InputProps={{
                                    startAdornment: <InputAdornment position="start"><i className='material-icons pm-input-icon'>lock</i></InputAdornment>,
                                }}
                            />
                        </Grid>


                        {!this.state.verifyCaptcha &&
                            <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={12} lg={12} xl={12} >
                                <form onSubmit={this.onSubmitWithReCAPTCHA}>
                                    <div style={{ width: 'fit-content', margin: 'auto' }}>
                                        <ReCAPTCHA
                                            ref={this.recaptchaRef}
                                            sitekey="6LeTWNYZAAAAAOgqwr39rLDHu6rVc0OuzoPKKSfp"
                                            onChange={this.changeCaptcha}
                                        />
                                    </div>

                                </form>
                            </Grid>
                        }




                        <span className='pm-warning-validate'>{this.state.labRez}</span>
                        {this.state.verifyCaptcha &&
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="loginButton" >
                                <Button variant="outlined" className='pm-login-button' color="primary" onClick={this.checkAndLogin}>
                                    {this.dictionary.login.logIn}
                                </Button>
                                {/* <span className='pm-login-signup-text-container'><span className='pm-appbar-list-text'>{this.dictionary.login.or}</span> <span onClick={() => { this.props.history.push('/signup') }} className='pm-appbar-signup-text'>{this.dictionary.login.signUp}</span></span> */}


                            </Grid>
                        }

                        {/* <Grid item style={{
                            textAlign: 'right',
                            padding: '10px 40px'
                        }} xs={12} sm={12} md={12} lg={12} xl={12}>
                            <span>   {this.dictionary.login.noAccount}<strong onClick={this.changeView} style={{ textDecoration: 'underline', cursor: 'pointer' }}> {" " + this.dictionary.login.clickHere}</strong></span>

                        </Grid> */}




                    </Grid>

                }


                {!this.state.logIn &&
                    <SignUp
                        history={this.props.history}
                        changeView={this.changeView}
                    />
                }




            </div>
        );
    }


}  // end class